export const EndoPriceData = [
    {
        id: 1,
        service: 'Восстановление зуба пломбой',
        price: '3000 - 7000',
    },
    {
        id: 2,
        service: 'Инструментальная и медикаментозная обработка корневого канала',
        price: '2000 - 2500',
    },
    {
        id: 3,
        service: 'Пломбирование корневого канала зуба гуттаперчевыми штифтами',
        price: '1500',
    },
    {
        id: 4,
        service: 'Временное восстановление разрушенного зуба композитом',
        price: '3000',
    },
]